import { render, staticRenderFns } from "./reviseLssues.vue?vue&type=template&id=054fbf07&scoped=true&"
import script from "./reviseLssues.vue?vue&type=script&lang=js&"
export * from "./reviseLssues.vue?vue&type=script&lang=js&"
import style0 from "./reviseLssues.vue?vue&type=style&index=0&id=054fbf07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054fbf07",
  null
  
)

export default component.exports